import { useFlagSuperOnaEnabled } from "@/hooks/use-flag";
import type { PlainEnvironment } from "@/queries/environment-queries";
import { environmentHasReachedStablePhase, showStart } from "@/routes/environments/phase";

/**
 * Returns whether the Start action should be enabled for the given environment.
 *
 * When SuperOna is enabled, Start is allowed during the stopping phase so users
 * can restart without waiting for a full stop. When the flag is off, the old
 * behavior is preserved: Start is only enabled once the environment reaches a
 * stable phase (desired === actual).
 */
export function useCanStartEnvironment(environment: PlainEnvironment | undefined): boolean {
    const { value: isSuperOnaEnabled } = useFlagSuperOnaEnabled();

    if (!environment) {
        return false;
    }

    if (!showStart(environment)) {
        return false;
    }

    // SuperOna users can start during stopping; others must wait for stable phase.
    if (isSuperOnaEnabled) {
        return true;
    }

    return environmentHasReachedStablePhase(environment);
}
